/*document.querySelectorAll('.tabs').forEach(tabsInstance => {
    const tabLinks = tabsInstance.querySelectorAll('.tablinks a');
    console.log(tabLinks);
    const tabPanels = tabsInstance.querySelectorAll('.panel');
    tabLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const targetPanelId = this.getAttribute('href').substring(1);
            const targetPanel = tabsInstance.querySelector('#' + targetPanelId);
            if (targetPanel) {
                // Hide all panels in this instance
                tabPanels.forEach(panel => {
                    panel.style.display = 'none';
                });
                // Remove active class from all links in this instance
                tabLinks.forEach(link => {
                    link.classList.remove('active');
                });
                // Show the target panel and set the link as active
                targetPanel.style.display = 'block';
                this.classList.add('active');
            } else {
                console.error(`Panel with ID ${targetPanelId} not found in this tabs instance.`);
            }
        });
    });
});

*/
const tabLinks = document.querySelectorAll('.tablinks a');
const tabPanels = document.querySelectorAll('.tabs .panel');
tabLinks.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();

        const siblingLinks = Array.from(this.closest('.tablinks').querySelectorAll('a'));

        const targetPanelId = this.getAttribute('href').substring(1);
        const targetPanel = document.getElementById(targetPanelId);

        if (targetPanel) {
            // Hide all panels
            tabPanels.forEach(panel => {
                // if in sibling panels, hide, otherwise leave as is
                if (siblingLinks.some(siblingLink => siblingLink.getAttribute('href').substring(1) === panel.id)) {
                    panel.style.display = 'none';
                }
            });
            // Remove active class from all links
            tabLinks.forEach(link => {
                if (siblingLinks.includes(link)) {
                    link.classList.remove('active');
                }
            });
            // Show the target panel and set the link as active
            targetPanel.style.display = 'block';
            this.classList.add('active');
        } else {
            console.error(`Panel with ID ${targetPanelId} not found.`);
        }
    })
})
